
export class PartCategory {
  id: number = -1;
  name: string = '';
  createdBy: number = -1;
  createdAt: string = '';
  updatedAt: string = '';
}
